import { Accordion } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import classnames from "classnames";
import { default as React, useEffect, useState } from "react";
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";
import ContactChat from "../contact-details-box/contact-methods/contact-chat/ContactChat";
import { useFeatureFlag } from "@/context/FeatureFlagContext";
import OtherProductSolution from "./OtherProductSolution";
import SlideIn from "@/components/slide-in/SlideIn";
import ContactDetailsBox from "@/components/contact-details-box/ContactDetailsBox";
import styles from "./contact-us-non-electrical-solution.module.scss";

function ContactUsNonElectricalSolution({ solution: { id, hierarchyPosition }, className }) {
  const showNewProminentLiveChat = useFeatureFlag("show_new_prominent_live_chat");

  const getSolutionComponent = solutionID => {
    switch (solutionID) {
      case "other":
        return OtherProductSolution;
      default:
        return null;
    }
  };
  const [liveChatConfig, setLiveChatConfig] = useState(null);
  const SolutionComponent = getSolutionComponent(id);
  const location = hierarchyPosition.join(" | ");

  useEffect(() => {
    getSolutionContactDetails(location).then(config => {
      setLiveChatConfig(config.chat);
    });
  }, []);

  const contactFields = [
    { name: "email", key: "email" },
    { name: "chat", key: "channel" },
  ];

  return (
    <article className={classnames(styles.nonElectricalSolution, className)} data-solution-id={id}>
      <h2 className={styles.nonElectricalSolution__top}>Did you know</h2>
      <div className={styles.nonElectricalSolution__inner} data-test="solution-inner">
        <SolutionComponent />
        {showNewProminentLiveChat ? (
          <SlideIn>
            <ContactDetailsBox
              title="We’re here to help"
              fields={contactFields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
              solutionId={setLiveChatConfig?.solution}
              location={location}
              otherContactDetails={setLiveChatConfig}
              viewContactDetails
              showGreyBackground
              showEmailOption={false}
            />
          </SlideIn>
        ) : (
          <div className={styles.nonElectricalSolution__bottom}>
            <h2>Choose your contact method</h2>
            <div className={styles.contactMethodsContainer}>
              <div className={styles.contactMethodContainer}>
                <span className={styles.contactMethodTitle}>Email or call us</span>
                <p className={styles.contactMethodDescription}>
                  Submit your photos via our email form, and you’ll get a case reference and a phone number you can call
                  us on. If you'd prefer to wait, we'll get back to you via email within 24 hours.
                </p>

                <SecondaryButton
                  tag="a"
                  href="/customer-services/email-us?t=problemsWithProduct-problemsOther"
                  role="link"
                >
                  Email us
                </SecondaryButton>
              </div>
              <div className={styles.contactMethodContainer}>
                <span className={styles.contactMethodTitle}>Live chat with John lewis</span>
                {!liveChatConfig && <LoadingSpinner />}
                {liveChatConfig && (
                  <>
                    {liveChatConfig.open && (
                      <>
                        <p>Contact our team via our website. You can save the chat transcript for reference.</p>
                        <div className={styles.liveChatContactMethodOpeningTimes}>
                          <span>7 days a week</span>
                          <span>8am - 9pm</span>
                        </div>
                      </>
                    )}

                    <ContactChat
                      className={styles.liveChatContainer}
                      config={liveChatConfig}
                      location={location}
                      displayOpeningHours={false}
                      displayDescriptionParagraph={false}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {!showNewProminentLiveChat && (
          <div className={styles.nonElectricalSolution__accordian}>
            <Accordion label="Have a different problem?" size="S" animated={false}>
              Call 03456 100 342 to speak to one of our Partners. Please have your order number ready.
            </Accordion>
          </div>
        )}
      </div>
    </article>
  );
}

export default ContactUsNonElectricalSolution;
